import { render, staticRenderFns } from "./HeaderRegister.vue?vue&type=template&id=a763784c"
import script from "./HeaderRegister.vue?vue&type=script&lang=ts"
export * from "./HeaderRegister.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports